import { all } from "redux-saga/effects";
import authSaga from "./auth/saga";
import homepageSagas from "./homepage/saga";
import languageSaga from "./languages/saga";
import systemSaga from "./system/saga";

export default function* rootSaga() {
  yield all([...authSaga, ...languageSaga, ...homepageSagas,...systemSaga]);
}
